// extracted by mini-css-extract-plugin
export default {"skills-grid":"Skills_skills-grid__oyGaP","container":"Skills_container__V6PUl"};